import React from 'react'
import RewardLeaderboardPage from './RewardLeaderboardPage'

const RewardRankPage: React.FC = () => <RewardLeaderboardPage tab="rank" />

export default RewardRankPage
